
interface UnderlineTitleProps {
  title: string;
  style?: React.CSSProperties;
}

export default function UnderlineTitle({ title, style }: UnderlineTitleProps) {
  return (
    <span className={`relative text-[24px] font-[700] text-gray-900`} style={style}>
      <span className="relative z-10">{title}</span>
      <span className="absolute bottom-0 left-0 right-0 w-16 h-3 bg-[#F0FCFC] mt-2" />
    </span>
  );
}

